/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Scan_GroupsInputs */

const en_scan_groups = /** @type {(inputs: Scan_GroupsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Scanning for active community groups...`)
};

const id_scan_groups = /** @type {(inputs: Scan_GroupsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Memindai grup komunitas aktif...`)
};

/** @type {(inputs: Scan_GroupsInputs) => LocalizedString} */
const es_scan_groups = en_scan_groups;

/** @type {(inputs: Scan_GroupsInputs) => LocalizedString} */
const fr_scan_groups = en_scan_groups;

/** @type {(inputs: Scan_GroupsInputs) => LocalizedString} */
const de_scan_groups = en_scan_groups;

/** @type {(inputs: Scan_GroupsInputs) => LocalizedString} */
const ja_scan_groups = en_scan_groups;

/** @type {(inputs: Scan_GroupsInputs) => LocalizedString} */
const zh_scan_groups = en_scan_groups;

/** @type {(inputs: Scan_GroupsInputs) => LocalizedString} */
const ar_scan_groups = en_scan_groups;

/** @type {(inputs: Scan_GroupsInputs) => LocalizedString} */
const it_scan_groups = en_scan_groups;

/** @type {(inputs: Scan_GroupsInputs) => LocalizedString} */
const ru_scan_groups = en_scan_groups;

/** @type {(inputs: Scan_GroupsInputs) => LocalizedString} */
const pt_scan_groups = en_scan_groups;

/** @type {(inputs: Scan_GroupsInputs) => LocalizedString} */
const ko_scan_groups = en_scan_groups;

/**
* | output |
* | --- |
* | "Scanning for active community groups..." |
*
* @param {Scan_GroupsInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const scan_groups = /** @type {((inputs?: Scan_GroupsInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Scan_GroupsInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_scan_groups(inputs)
	if (locale === "es") return es_scan_groups(inputs)
	if (locale === "fr") return fr_scan_groups(inputs)
	if (locale === "de") return de_scan_groups(inputs)
	if (locale === "ja") return ja_scan_groups(inputs)
	if (locale === "zh") return zh_scan_groups(inputs)
	if (locale === "ar") return ar_scan_groups(inputs)
	if (locale === "id") return id_scan_groups(inputs)
	if (locale === "it") return it_scan_groups(inputs)
	if (locale === "ru") return ru_scan_groups(inputs)
	if (locale === "pt") return pt_scan_groups(inputs)
	return ko_scan_groups(inputs)
});